/**
 * useSessions Hooks
 * TanStack Query hooks for session management
 */

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { sessionsService } from '@/services/api/profile';

export const sessionsQueryKey = ['sessions'] as const;

/**
 * Hook for fetching active sessions
 */
export function useSessions() {
  return useQuery({
    queryKey: sessionsQueryKey,
    queryFn: () => sessionsService.getSessions(),
    staleTime: 1000 * 60 * 2,
  });
}

/**
 * Hook for revoking a single session
 */
export function useRevokeSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => sessionsService.revokeSession(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sessionsQueryKey });
    },
  });
}

/**
 * Hook for revoking all other sessions
 */
export function useRevokeAllSessions() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => sessionsService.revokeAllOtherSessions(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: sessionsQueryKey });
    },
  });
}
